import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from "./redux/store";
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

import {LicenseManager} from "ag-grid-enterprise";
if(process.env.REACT_APP_ENVNVIRONMENT === "production") {
  console.log('REACT_APP_ENVNVIRONMENT is production');
}
if(process.env.REACT_APP_ENV === "production") {
  console.log('REACT_APP_ENV is production');
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY);
}
else{
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY);
}

ReactDOM.render(
  // <React.StrictMode>
    <AppProvider i18n={enTranslations}>
      <Provider store={store}>
        <App />
      </Provider>
    </AppProvider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
